const term = {
	config: {
		html: false,
		xhtmlOut: false,
		breaks: false,
		linkify: false,
	},
	disabled: [
		"blockquote",
		"fence",
		"hr",
		"reference",
		"autolink",
		"image",
		"link",
		"newline",
	],
};

const fact = {
	config: {
		html: false,
		xhtmlOut: false,
		breaks: false,
		linkify: false,
	},
	disabled: [
		"blockquote",
		"fence",
		"heading",
		"hr",
		"reference",
		"autolink",
		"image",
		"link",
		"newline",
	],
};

const description = {
	config: {
		html: false,
		xhtmlOut: false,
		breaks: true,
		linkify: false,
	},
	disabled: ["autolink", "image", "link"],
};

const stem = {
	config: {
		html: true,
		xhtmlOut: true,
		breaks: true,
		linkify: false,
	},
	disabled: ["autolink"],
};

const answer = {
	config: {
		html: true,
		xhtmlOut: true,
		breaks: false,
		linkify: false,
	},
	disabled: ["blockquote", "fence", "hr", "list", "reference"],
};

const explanation = {
	config: {
		html: true,
		xhtmlOut: true,
		breaks: true,
		linkify: true,
	},
	disabled: [] as string[],
};

const rules = {
	term,
	fact,
	description,
	stem,
	answer,
	explanation,
};

export default rules;
